import { useEffect, useState } from "react";
import { Button, Box, TextField } from "@mui/material";
import { UseAdvertismentGroup } from "./UseAdvertismentGroup";
import { useNavigate, useLocation } from "react-router-dom";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { rsGotoLast, rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function AddAdvGroup(props) {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const navigate = useNavigate();
  const location = useLocation();
  const [group, setGroup] = useState();
  const { validate, addGroup } = UseAdvertismentGroup();
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { isSmall } = useBreakpoints();

  const [state, setState] = useState({
    id: undefined,
    title: undefined,
    rowIndex: undefined,
  });

  const [errorState, setErrorState] = useState({
    title: false,
    id: false,
  });

  useEffect(() => {
    var lastrowIndex = Math.max.apply(
      Math,
      location.state?.items &&
        location.state?.items.map(function (o) {
          if (o) {
            return o.rowIndex;
          } else {
            return 1;
          }
        })
    );
    setState({
      ...state,
      rowIndex: lastrowIndex != -Infinity ? lastrowIndex + 1 : 1,
    });
  }, [location.state]);

  return (
    <Detail
      breadChilds={{
        title: "تبلیغات",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/advertismentgroup" },
          { name: "گروه تبلیغات جدید", url: "/advertismentgroup/addgroup" },
        ],
      }}
    >
      {!group ? (
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn={isSmall ? "span 12" : "span 2"}>
            <TextField
              fullWidth
              value={state.id ? state.id : ""}
              error={errorState.id}
              sx={{
                input: {
                  textAlign: "center",
                },
              }}
              label="ID"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, id: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 10"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              fullWidth
              value={state.title ? state.title : ""}
              error={errorState.title}
              label="عنوان"
              size="small"
              variant="outlined"
              onChange={(evt) => {
                setState({ ...state, title: evt.target.value });
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}

          <Box
            gridColumn={isSmall ? "span 12" : "span 3"}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              sx={{ mr: 2, width: "100px" }}
              variant="contained"
              color="secondary"
              onClick={() => {
                if (validate(state, setErrorState) == 200) {
                  setProgress(true);
                  setMsGotoLast(true);
                  addGroup(state, () => {
                    navigate("/advertismentgroup", {
                      state: { ...location.state, isBack: true },
                      replace: true,
                    });
                  });
                }
              }}
            >
              ثبت
            </Button>
            <Button
              sx={{ width: "100px" }}
              variant="outlined"
              color="secondary"
              onClick={() => {
                navigate("/advertismentgroup", {
                  state: { ...location.state, isBack: true },
                  replace: true,
                });
              }}
            >
              بازگشت
            </Button>
          </Box>
        </Box>
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}
